import { connect } from "react-redux";
var {STUDENT_ENTITY_TYPE, STUDENT_LIST_ENTITY_TYPE, TEACHER_ENTITY_TYPE, SCHOOL_ORG_ENTITY_TYPE, DISTRICT_ORG_ENTITY_TYPE, YEARLY, PERIOD, GRAPH} = require("lib/widgets/WidgetsConfig")
var {STAT_DISPLAY, ACTIVITY_METRICS, RUBRIC_METRICS, calculateRubricScore} = require("components/data/graphs/GraphUtility")

var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var CurrentUser = require("lib/account/CurrentUser");

var ButtonDropdown = require("components/utility/ButtonDropdown")
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption")
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var RosterActions = require("lib/actions/RosterActions");
var DataActions = require("lib/actions/DataActions");
var Spinner = require("components/utility/Spinner");

require("appdev/wizards/digests_page.scss")


const ENTITY_TYPES = [STUDENT_ENTITY_TYPE, STUDENT_LIST_ENTITY_TYPE, TEACHER_ENTITY_TYPE, SCHOOL_ORG_ENTITY_TYPE, DISTRICT_ORG_ENTITY_TYPE]
const METRICS_TO_DISPLAY = _.select(ACTIVITY_METRICS, met=>(met != 'quiz_performance'))
@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		fetchEntity(id, type){
            if (type == STUDENT_ENTITY_TYPE){
                return dispatch(RosterActions.fetchStudent({id: id}))
            } else if (type == STUDENT_LIST_ENTITY_TYPE){
                return dispatch(RosterActions.fetchStudentList({id: id}))
            } else if (type == TEACHER_ENTITY_TYPE){
                return dispatch(RosterActions.fetchAdmins({filters: { ids: [id] }}))
            } else if (type == SCHOOL_ORG_ENTITY_TYPE){
                return dispatch(RosterActions.fetchSchoolOrgs({filters: {ids: [id]}}))
            } else if (type == DISTRICT_ORG_ENTITY_TYPE){
                return dispatch(RosterActions.fetchDistrictOrgs({filters: {ids: [id]}}))
            }
        },
        fetchDigests(id, type){
            var conditions = {entityType: type, entityID: id, digestSummary: true }
            return dispatch(DataActions.fetchDigests({
                conditions: conditions,
                cache: false
            }))
        },
        triggerJob(id, type, what){
            return dispatch(DataActions.postWidgetJobTrigger({id, type, what}))
        }
	})
)



class DigestsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        var entityID = $wr.getURLParameterByName("entity_id")
        var entityType = $wr.getURLParameterByName("entity_type")
        
		this.state = { 
            entityID: entityID,
            entityType: entityType,
            loading: false,
            entity: null,
            digests: null,
            graphView: PERIOD
		}
	}

    getDataKey(){
        if (this.state.entityType == STUDENT_ENTITY_TYPE){
            return 'students'
        } else if (this.state.entityType == STUDENT_LIST_ENTITY_TYPE){
            return 'studentLists'
        } else if (this.state.entityType == TEACHER_ENTITY_TYPE){
            return 'admins'
        } else if (this.state.entityType == SCHOOL_ORG_ENTITY_TYPE){
            return 'schoolOrgs'
        } else if (this.state.entityType == DISTRICT_ORG_ENTITY_TYPE){
            return 'districtOrgs'
        }
    }

    changeEntityType(type){
        this.setState({entityType: type})
    }

    changeEntityID(e){
        $wr.nope(e)
        this.setState({entityID: e.target.value})
    }

    search(e){
        $wr.nope(e)
        this.setState({loading: true})

        
        this.props.fetchEntity(this.state.entityID, this.state.entityType).then(res=>{
            var datakey = this.getDataKey()
            if (res[datakey].length){
                var entity = res[datakey][0]
            } else {
                var entity = null
            }
            this.setState({loading: false, entity: entity})
        })
    }

    onViewChange(newView){
        this.setState({graphView: newView})
    }

    handleClick(action){
        this.props.triggerJob(this.state.entityID, this.state.entityType, action).then(res=>{
            if (res.success){
                if (action == 'reset'){
                    var text = 'Check back in ~5 minutes.'
                } else {
                    var text = 'Entity has been flagged'
                }
                window.wrNotifications.triggerDropDownNotification({
                    title: 'Success!',
                    text: text,
                    icon: "ok-circle",
                });
            }
        })
    }

    renderControlSection(){
        if (this.state.entity) {
            if ([STUDENT_ENTITY_TYPE, TEACHER_ENTITY_TYPE].includes(this.state.entityType)){
                var entityName = `${this.state.entity.first_name} ${this.state.entity.last_name} (${this.state.entityType})`
            } else {
                var entityName = this.state.entity.name
            }
            var nameHeader = <h3> {entityName} </h3>
            
            var clearButton = (
                <div className='removalBtn' onClick={()=>this.setState({entity: null, entityID: null, digests: null, entityType: null})}>
                    <Glyphicon icon="remove-circle" />
                </div>
            )
            
            
            var nameHeader = (
                <div className='titleContainer'>
                    <h3> {entityName}</h3>
                    {clearButton}
                </div>
            )
            
            var graphToggleOptions = [PERIOD, YEARLY, GRAPH].map(digestType=>({key: digestType, text: digestType}))

            var viewToggle = <DisplayToggleControl options={ graphToggleOptions } onChange={ this.onViewChange } className="hideOnPrint"activeOptionKey={ this.state.graphView } />
            
            var recalculateButton = <button onClick={()=>{this.handleClick('reset')}} className='btn btn-danger'> Reset </button>
            var flagButton = <button onClick={()=>{this.handleClick('flag')}} className='btn btn-primary'> Flag </button>
            
            var explainerGlyph = <Glyphicon icon='question-sign' dataTip="Reset clears and recalculates all digests of an entity (and its sub-entities) instantly. Flag marks the entity and sub-entities for our nightly recalculation proccess."/>

            var btnContainer = (
                <div className='btnContainer'>
                    {flagButton}
                    {recalculateButton}
                    {explainerGlyph}
                </div>
            )
            return (
                <div className='entityControls'>
                    {nameHeader}
                    {viewToggle}
                    {btnContainer}
                </div>
            )

            
        } else {
            var entityTypeOptions = ENTITY_TYPES.map(type=>{
                return <ButtonDropdownOption onClick={this.changeEntityType.bind(this, type)}
                    text={type} key={type}/>
            })
    
            var text = this.state.entityType || "Choose an entity type"
    
            var entityDropdown = (
                <ButtonDropdown text={text}>
                    {entityTypeOptions}
                </ButtonDropdown>
            )
    
            
    
            return (
                <div className='searchControls'>
                    <input type="text" value={this.state.entityID} placeholder="User ID" className="form-control idInput" onChange={this.changeEntityID.bind(this)} />
                    {entityDropdown}
                    <LoadingButton className="btn buttonPrimary" onClick={this.search} loading={this.state.loading} text="Search" />        
                </div>
            )
        }
    }

    renderDigestTables(){
        if(!this.state.entity) {return}
        if (!this.state.digests){return <Spinner />}
        
        if (this.state.graphView == PERIOD){
            var digests = _.select(this.state.digests, (digest)=> digest.period == PERIOD)
        } else if (this.state.graphView == YEARLY){
            var digests = _.select(this.state.digests, (digest)=> digest.period == YEARLY)
        } else if (this.state.graphView == GRAPH){
            var digests = _.select(this.state.digests, (digest)=> digest.graph)
        }

        digests.sort(function(a,b){
            return new Date(a.start_date) - new Date(b.start_date);
        })
        var table = (
            <div className='scrollable'>
                <table className="table table-striped table-bordered">
                    <tbody>
                        <tr>
                            <th> Start Date </th>
                            <th> End Date </th>
                            {METRICS_TO_DISPLAY.map(metric=>(
                                <th>{STAT_DISPLAY[metric].name}</th>
                            ))}
                            {this.state.graphView == GRAPH &&
                                RUBRIC_METRICS.map(rubric=>(
                                    <th>{STAT_DISPLAY[rubric].name}</th>
                                ))
                            }
                        </tr>
                        {digests.map(digest=> this.renderDigestRow(digest))}
                    </tbody>
                </table>
            </div>
        )
        
        return (
            <div className='tableContainer'>
                {table}
            </div>
        )
    }

    renderDigestRow(digest){
        return (
            <tr>
                <td>
                    {new Date(digest.start_date).toLocaleDateString()}
                </td>
                <td>
                    {new Date(digest.end_date).toLocaleDateString()}
                </td>
                {METRICS_TO_DISPLAY.map(metric=>{
                    return (
                        <td>
                            {digest.data[metric].toFixed(0)}
                        </td>
                    )
                })}
                {this.state.graphView == GRAPH && 
                    RUBRIC_METRICS.map(rubric=>{
                        return (
                            <td>
                                {calculateRubricScore(digest, rubric).toFixed(2)}
                            </td>
                        )
                    })
                }
            </tr>
        )
        
    }

    render(){

        var headerDisplay = (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>Digests Page</h1>
				</header>
			</div>
		);

        var controls = this.renderControlSection()

        var tables = this.renderDigestTables()
        return (
            <div className='DigestsPage container'>
                {headerDisplay}
                {controls}
                {tables}
            </div>
        )
    }

    componentDidUpdate(prevProps, prevState){
        if (this.state.entity && this.state.entity != prevState.entity){
            this.props.fetchDigests(this.state.entity.id, this.state.entityType).then(res=>{
                this.setState({digests: res.digests})
            })
        }
    }

    componentDidMount(){
        // if entity info already exists when the component mounts (url params), fetch entity.
        if (this.state.entityID, this.state.entityType){
            this.search()
        }
    }

};

DigestsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	fetchUsers: PropTypes.func.isRequired,
	mergeStudents: PropTypes.func.isRequired
});

module.exports = DigestsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/DigestsPage.js